module.exports = __webpack_public_path__ + "static/media/rank.430641d8.jpg";